// TabBar — 4 tabs (Inicio · Señales · Historial · Perfil). Handoff v3:
// barra flotante (`.tabs` del prototipo → `.v3tabs`), activo en acento
// sobre --accent-soft, icono 21px + label 10px/600.
import { useNavigate, useLocation } from 'react-router-dom';

const TABS = [
  { to: '/app', label: 'Inicio', icon: <path d="M3 10.5L12 3l9 7.5V21H3z" /> },
  { to: '/app/senales', label: 'Señales', icon: <path d="M3 17l5-6 4 4 5-8 4 5" /> },
  { to: '/app/historial', label: 'Historial', icon: <><rect x="3" y="4" width="18" height="17" rx="3" /><path d="M8 2v4M16 2v4M3 10h18" /></> },
  { to: '/app/perfil', label: 'Perfil', icon: <><circle cx="12" cy="8" r="4" /><path d="M4 21c0-4 3.6-6.5 8-6.5s8 2.5 8 6.5" /></> },
];

export default function TabBar() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  return (
    <nav className="v3tabs">
      {TABS.map((t) => (
        <button key={t.to} type="button"
          className={`v3tab${(t.to === '/app' ? pathname === '/app' : pathname.startsWith(t.to)) ? ' on' : ''}`}
          onClick={() => navigate(t.to)}>
          <svg width="21" height="21" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.1" strokeLinecap="round" strokeLinejoin="round">{t.icon}</svg>
          <span>{t.label}</span>
        </button>
      ))}
    </nav>
  );
}
